module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Well now, you want me to say all this is gospel? Choose what to believe and where to hang your hat; I don’t give no never mind. Mickey Free lived; he walked the white man’s path and the good red road and was at home in neither. This is his story. Mine, too. Maybe it’s the story of us all. There’s the truth of history and the truth of legend, but what really happened often lies somewhere in between.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And that’s the undiscovered country you hold in your hands.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("Apacheria: Being the Personal Memoirs of an Indian")])])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', [_c('i', [_vm._v("Fighter and Arizona Lawman")])])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('span', [_vm._v("— R. D. JORDAN, 1901")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36b0822c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter03.vue
// module id = 81
// module chunks = 0